<template>
  <div class="policy">
    <div class="law_statute">
      <div class="pol_container">
        <div v-show="!pupopShow" style="width: 95%; margin: auto">
          <div class="headerSearch">
            <div class="sousuo">
              <el-form
                style="display: flex"
                class="t_search_form"
                label-position="left"
                label-width="90px"
                :model="configForm"
              >
                <el-form-item label="公告标题:" label-width="100px">
                  <el-input
                    v-model="configForm.param.title"
                    placeholder="请输入"
                  />
                </el-form-item>
                <el-form-item label="发布机关:" label-width="90px">
                  <el-input
                    v-model="configForm.param.deptName"
                    placeholder="请输入"
                  />
                </el-form-item>
                <el-form-item label="发布时间:">
                  <el-col :span="10">
                    <el-date-picker
                      v-model="configForm.param.beginTime"
                      type="date"
                      style="width: 100%"
                      placeholder="开始时间"
                      value-format="yyyy-MM-dd"
                      :picker-options="startTime"
                    />
                  </el-col>
                  <el-col
                    style="text-align: center"
                    class="line"
                    :span="3"
                  >-</el-col>
                  <el-col :span="10">
                    <el-date-picker
                      v-model="configForm.param.endTime"
                      type="date"
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                      placeholder="结束时间"
                      :picker-options="endTime"
                    />
                  </el-col>
                </el-form-item>
                <el-button
                  v-preventReClick
                  class="sousuoButton"
                  icon="el-icon-search"
                  round
                  size="small"
                  type="primary"
                  @click="handleCurrentChange(1)"
                >搜索</el-button>
                <el-button
                  v-preventReClick
                  class="chongzhiButton"
                  size="small"
                  icon="el-icon-refresh-right"
                  round
                  @click="reset"
                >重置</el-button>
              </el-form>
            </div>
          </div>
          <div
            style="
              max-width: 1518px;
              background-color: white;
              padding-top: 40px;
              padding-bottom: 57px;
              margin-left: auto;
              margin-right: auto;
            "
          >
            <div class="tablemes">
              <el-table
                :data="tableData"
                border
                :show-overflow-tooltip="true"
                :header-cell-style="{ background: '#F2F2F2' }"
                style="width: 100%"
              >
                <el-table-column
                  align="center"
                  label="公告标题"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.title }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="发布机关"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.deptName }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="发布时间"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.publishTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="操作"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <el-button
                      v-preventReClick
                      icon="el-icon-document"
                      size="mini"
                      type="primary"
                      style="background: #4170ff"
                      @click="query(scope.row.flfgId)"
                    >查看</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                background
                layout="prev, pager,next,jumper,total,sizes"
                :page-sizes="[10, 20, 30]"
                :total="total"
                :page-size="configForm.size"
                class="el-page"
                :current-page.sync="configForm.page"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
              />
            </div>
          </div>
        </div>
      </div>
      <xxhd-document
        v-if="pupopShow"
        ref="xxhdDocument"
        :title="title"
        :fbsj="fbsj"
        :fbjg="fbjg"
        :content="content"
        :fj-url="fjUrl"
      />
    </div>
    <!-- <div
      v-if="!pupopShow"
      style="
        width: 95%;
        background-color: white;
        margin: auto;
        margin-top: 30px;
        padding: 40px 0 40px;
      "
    >
      <div class="tablemes">
        <el-table
          :header-cell-style="{ background: '#F2F2F2' }"
          border
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="公告标题"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="发布机关"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.deptName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="发布时间"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.publishTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                icon="el-icon-document"
                size="mini"
                type="primary"
                style="background: #4170ff"
                   v-preventReClick   @click="query(scope.row.flfgId)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager,next,jumper,total,sizes"
          :page-sizes="[10, 20, 30]"
          :total="total"
          :page-size="pagesize"
          class="el-page"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
        >
        </el-pagination>
      </div>
    </div>
    <xxhd-document
      :title="title"
      :fbsj="fbsj"
      :fbjg="fbjg"
      :content="content"
      :fjUrl="fjUrl"
      v-if="pupopShow"
      ref="xxhdDocument"
    ></xxhd-document> -->
  </div>
</template>
<script>
import XxhdDocument from '../xxhdDocument.vue'
import { zcwjTableList, getListItemById } from '@/assets/js/common.js'
import { hSYzcwj, APIhuoquxiangqingSY } from '@/assets/js/wangshuai.js'
export default {
  components: { XxhdDocument },
  props: ['clckiName'],
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.configForm.param.endTime) {
            return (
              time.getTime() > new Date(this.configForm.param.endTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.configForm.param.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() <
                new Date(this.configForm.param.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      configForm: {
        page: 1,
        size: 10,
        param: {
          title: '',
          deptName: '',
          beginTime: '',
          endTime: ''
        }
      },
      title: '',
      fjUrl: '',
      fbsj: '',
      fbjg: '',
      content: '',
      pupopShow: false,
      loading: false,
      total: 6,
      pagesize: 4,
      currentPage: 1,
      tableData: []
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getzcwjList()
  },
  created() {},
  beforeDestroy() {},
  methods: {
    reset() {
      this.configForm = {
        page: 1,
        size: 10,
        param: {
          title: '', // 输入框
          deptName: '', // 输入框
          beginTime: '',
          endTime: ''
        }
      }
      this.getzcwjList()
    },
    // 获取政策文件的list
    getzcwjList() {
      if (this.clckiName == '首页') {
        hSYzcwj(this.configForm).then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.data.rows
            this.total = res.data.data.total
          }
        })
      } else {
        zcwjTableList(this.configForm).then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.data.rows
            this.total = res.data.data.total
          }
        })
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.configForm.page = val
      this.getzcwjList()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.configForm.size = val
      this.getzcwjList()
    },
    query(curId) {
      this.pupopShow = true
      if (this.clckiName == '首页') {
        APIhuoquxiangqingSY(curId).then((res) => {
          if (res.status == 200) {
            this.title = res.data.data.title
            this.fbsj = res.data.data.publishTime
            this.fbjg = res.data.data.deptName
            this.content = res.data.data.content
            this.fjUrl = res.data.data.fj
          }
        })
      } else {
        getListItemById(curId).then((res) => {
          if (res.status == 200) {
            this.title = res.data.data.title
            this.fbsj = res.data.data.publishTime
            this.fbjg = res.data.data.deptName
            this.content = res.data.data.content
            this.fjUrl = res.data.data.fj
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/.el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 32px;
  width: 30px !important;
  color: #303133;
}
.pol_container {
  // height: 100%;
  .headerSearch {
    max-width: 1518px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        // width: 90px;
        // height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
</style>
